var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bar"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('copyright', [_vm.version]))}})])}
var staticRenderFns = []

export { render, staticRenderFns }